import React from 'react';
import styled from 'styled-components';

const TokenomicsContainer = styled.div`
  .tokenomics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .tokenomics-item {
    background: var(--gray);
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

    h3 {
      font-size: 1.3rem;
      color: var(--light);
      margin: 0 0 10px;
    }

    p {
      color: #ccc;
      font-size: 0.9rem;
    }
  }
`;

const Tokenomics = () => {
  const items = [
    { title: 'Sustainable Fair Launch', description: '89% Community Mintable, The Rest Reinvested into Project Expansion' },
    { title: 'Decentralized Partnership', description: 'No Venture Capital Launch– KaspaSphere.com DAO with its Community Treasury Wallet will total only ~1% max supply held; DAO Never Dumps, Does Supply Burns' },
    { title: 'Token Details', description: '357,350,420 Coins – Seconds from Snowden Exile to KRC-20 Network Release! Ticker: $SNOWDN | 42 Tokens per 1 KAS Mint | An Official Economic Token of KaspaSphere DAO.' },
    { title: 'Allocation', description: '1% (3M) to KaspaSphere DAO Treasury. Rest of Pre-Mint Will Only be: Gradually Burned and then the remaining listed within a Top Tier Liquidty Pool.' },
    { title: 'Launch Team', description: 'One-Time, Singular (42 Tokens Only) Personal Mint Per Team Member Pledge. Never changes.' },
  ];

  return (
    <TokenomicsContainer>
      <h2>Tokenomics</h2>
      <div className="tokenomics-grid">
        {items.map(item => (
          <div className="tokenomics-item" key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </TokenomicsContainer>
  );
};

export default Tokenomics;
